// oxlint-disable jsx-no-new-object-as-prop

import { EASE } from "@nnf3d/lib";
import { useStore } from "@tanstack/react-store";
import { AnimatePresence, m, stagger } from "motion/react";

import { useGlobal } from "../lib/global-context";
import { loadStore } from "../lib/store";
import type { VoidComponent } from "../lib/types";
import { booleanAttribute, urlFromSanityId } from "../lib/utils";

interface Props {
	inMask?: boolean;
}

const LoaderVideos: VoidComponent<Props> = ({ inMask }) => {
	const { pillars } = useGlobal();

	const { isStarted } = useStore(loadStore);

	return (
		<AnimatePresence>
			{!isStarted && (
				<div
					className="group absolute inset-0 z-110 p-8 data-in-mask:-scale-y-100"
					data-in-mask={booleanAttribute(inMask)}
				>
					<m.div
						className="pointer-events-none absolute top-4 right-4 bottom-4 left-4 flex flex-col items-center justify-center gap-0 desktop:flex-row desktop:gap-16"
						variants={{
							initial: {},
							animate: { transition: { delayChildren: stagger(0.2, { startDelay: 0.5 }) } },
							exit: { transition: { delayChildren: 0 } },
						}}
						initial="initial"
						animate="animate"
						exit="exit"
					>
						{pillars.map((pillar) => (
							<m.div
								className="relative flex size-[calc(100%-2rem)] items-center justify-center overflow-hidden desktop:size-[26vw]"
								key={pillar._key}
								variants={{
									initial: { opacity: 0 },
									animate: { opacity: 1, transition: { duration: 1, ease: EASE.OUT_EXPO } },
									exit: { opacity: 0, transition: { duration: 0.7, ease: EASE.IN_EXPO } },
								}}
							>
								<div className="absolute -inset-100 bg-surface-primary group-data-in-mask:bg-white" />

								<video
									className="absolute size-[calc(100%+14rem)] max-w-none mix-blend-multiply saturate-120"
									autoPlay
									muted
									loop
									aria-label={`${pillar.title} loading animation`}
								>
									<track kind="captions" />

									<source
										src={urlFromSanityId(pillar.loaderVideo.asset._ref) ?? undefined}
										type="video/mp4"
									/>
								</video>
							</m.div>
						))}
					</m.div>
				</div>
			)}
		</AnimatePresence>
	);
};

export { LoaderVideos };
